module.exports = __webpack_public_path__ + "img/sld_mfm_battery_1_t1_b1_dark.243c40b6.svg";